module.exports = __webpack_public_path__ + "img/ready-img.f25a8d3f.svg";